import axiosInstance from "../axiosHelper/interceptor";
const STUDY_ENDPOINT = "/api/studies";
const useStudy = () => {
    const submitStudy = async (study) => {
        const postStudyProps = {
            ...study,
            refracDate: study.refracDate.format("YYYY-MM-DD")
        };
        try {
            const response = await axiosInstance.post(STUDY_ENDPOINT, postStudyProps);
            console.log("Study submitted successfully: ", response.data);
            return response.data;
        }
        catch (e) {
            console.error("Error submitting study: ", e);
        }
    };
    const getStudy = async (uuid) => {
        const get_endpoint = STUDY_ENDPOINT + "/" + uuid;
        try {
            const response = await axiosInstance.get(get_endpoint);
            return response.data;
        }
        catch (error) {
            console.error("Error getting study: ", error);
            return { records: [], headers: [], studyUuid: "", studyName: "", summary: { min: {}, max: {}, average: {}, median: {} } };
        }
    };
    const listStudies = async () => {
        try {
            const response = await axiosInstance.get(STUDY_ENDPOINT);
            return response.data;
        }
        catch (error) {
            console.error("Error listing studies: ", error);
            return { records: [], headers: [] };
        }
    };
    return {
        submitStudy,
        getStudy,
        listStudies
    };
};
export default useStudy;
